import { Trans, useTranslation } from '@exam-room/translations';

import { LoadingSpinner } from '../../../../components';
import { useExamEvent } from '../../../../providers';
import { mapExams } from '../../../exam/instruction/utils';
import { ExamCourse } from '../components';

export interface ExamCourseType {
  title: string;
  startDate: Date;
  endDate: Date;
  courses: {
    title: string;
    questionCount: number;
    isPassRequired: boolean;
  }[];
}

export default function ExamDetails() {
  const { t } = useTranslation();

  const { examEvent, examsData, isLoadingExams, closestExam } = useExamEvent();

  const metadata = examEvent?.metadata;
  const mainExam = examEvent?.exam;
  const examEvents = metadata?.events ?? [];

  if (isLoadingExams) {
    return <LoadingSpinner />;
  }

  const exams = mapExams(examEvents, examsData, closestExam?.order ?? 0);

  const questionCount = exams.reduce((acc, examEvent) => acc + (examEvent?.totalQuestions ?? 0), 0);

  const sectionCount = exams.reduce(
    (acc, examEvent) => acc + (examEvent?.structures?.length ?? 0),
    0,
  );

  const passingCriteriaTotal = mainExam?.metadata?.passingCriteria?.total;

  const passingCriteria = (
    typeof passingCriteriaTotal === 'number' ? passingCriteriaTotal : 0
  ).toFixed(2);

  return (
    <div className='flex w-full flex-col gap-4 text-left'>
      <div className='flex flex-col gap-2'>
        <h4 className='border-primary-500 border-l-4 pl-4 font-semibold'>
          {t('instruction.examDetails.title')}
        </h4>
        <p className='text-text-secondary pl-5'>
          <Trans
            i18nKey='instruction.examDetails.description'
            values={{
              questionCount,
              sectionCount,
              passingCriteria,
            }}
          />
        </p>
      </div>
      {exams.map((exam, index) => (
        <ExamCourse
          key={`${exam.title}-${index}`}
          title={exam.title}
          startDate={new Date(exam.startedAt)}
          endDate={new Date(exam.endedAt)}
          courses={exam.structures}
          status={exam.status}
        />
      ))}
    </div>
  );
}
